import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useEffect, useRef, useContext } from 'react'

import Svg from '../Svg/Svg'
import { UserContext } from '@/root/context/UserContext'

const InfoBox = (props) => {
  const { content, modifiers, match } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const createMarkup = (copy) => ({ __html: copy })
  const pointerRef = useRef()
  const tooltipRef = useRef()

  const getHeadingLength = (el, className) => {
    while (el && el.parentNode) {
      el = el.parentNode
      if (el.classList.contains(className)) {
        return el.parentNode.firstElementChild.clientWidth
      }
    }
    return null
  }

  useEffect(() => {
    tooltipRef?.current?.addEventListener('click', (e) => e.preventDefault())
    // Needs a timeout to wait for the header to be rendered
    if (!pointerRef?.current) return
    setTimeout(() => {
      const headingLength = getHeadingLength(pointerRef.current, 'InfoBox-wrapper')
      if (pointerRef?.current) pointerRef.current.style.left = `${headingLength + 4}px`
    }, 1000)

    return () => tooltipRef?.current?.removeEventListener('click', (e) => e.preventDefault())
  }, [])

  return (
    <>
      <a ref={tooltipRef} href="#" className="InfoBox--focus">
        {match && <span> {t('INFOBOX__LABEL')} </span>}
        <Svg id="icon-explainer" modifiers={['InfoBox--infoBoxIcon']} />
      </a>
      <div className={`InfoBox-wrapper has-infobox${modifierClasses}`} tabIndex="0">
        <div className="InfoBox">
          <div className="InfoBox-inner">
            <span className="InfoBox-content" dangerouslySetInnerHTML={createMarkup(content?.[0]?.tooltipText)}></span>
            <div ref={pointerRef} className="InfoBox-pointer"></div>
          </div>
        </div>
      </div>
    </>
  )
}

InfoBox.propTypes = {
  content: PropTypes.any.isRequired,
  modifiers: PropTypes.any,
  match: PropTypes.bool
}

export default InfoBox
